import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { FormattedMessage } from "react-intl";
import SharedComponentMessages from "core/shared/intl/SharedComponentMessages";

const StValue = styled.div`
  padding: 1rem;
  text-align: center;
`;

const EmptyRow = ({ msg }) => {
  return (
    <StValue>
      <FormattedMessage {...(msg || SharedComponentMessages.emptyMessage)} />
    </StValue>
  );
};

EmptyRow.propTypes = {
  msg: PropTypes.shape({
    defaultMessage: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }),
};

export default EmptyRow;
